import './create-rating-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column } from 'react-display-flex'

import { httpClient } from '../../../../../util/http-client'
import { ratingCompliancesRulesMessages } from '../messages'
import { createRatingComplianceRuleValues } from './models'
import { ratingComplianceRuleValidationSchema } from './validators'

interface CreateRatingComplianceProps {
  groupId: number
  domain: string
  onSuccess?: () => void
}

export const CreateRatingCompliance = ({ groupId, domain, onSuccess }: CreateRatingComplianceProps) => {
  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/ratings/groups/${groupId}/rules`, {
        method: 'POST',
        domain,
        data: formData,
      })
      notification.success({
        message: ratingCompliancesRulesMessages.common.success,
        description: ratingCompliancesRulesMessages.create.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: ratingCompliancesRulesMessages.common.error,
        description: error.error_message || ratingCompliancesRulesMessages.create.error,
      })
    }
  }

  return (
    <Formik
      initialValues={createRatingComplianceRuleValues}
      validationSchema={ratingComplianceRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="create-rating-compliance-rule">
        <FormItem name="ratingType" label="Rating Type" required>
          <Input name="ratingType" />
        </FormItem>
        <FormItem name="rating" label="Rating" required>
          <Input name="rating" />
        </FormItem>
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" min={0} />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
